import { tap, map } from 'rxjs/operators';
import { ApiResponse } from '@core/models/api-response.model';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Pagination } from '@core/models/pagination.model';
import { Injectable } from '@angular/core';

@Injectable()
export class VipSettingsDataService {

  pagination: Pagination;
  messages$ = new Subject<any[]>();
  locales$ = new BehaviorSubject([]);

  constructor(private http: HttpClient) { }

  getWithQuery(pageParam: string): Observable<[]> {
    return this.http.get<ApiResponse>(`/vipsetting${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  add(data: any) {
    return this.http.post<ApiResponse>(`/vipsetting`, data).pipe(
      tap(res => this.messages$.next(res.message))
    )
  }

  update(id: number, data: any) {
    return this.http.put<ApiResponse>(`/vipsetting/${id}`, data).pipe(
      tap(res => this.messages$.next(res.message))
    )
  }

  show(id: number, memberGroupId?: any): Observable<[]> {
    let params = memberGroupId ? '?member_group_id=' + memberGroupId : '';
    return this.http.get<ApiResponse>(`/vipsetting/${id}${params}`).pipe(
      map(res => res.data.rows[0])
    )
  }

  getVIPNameLocales(memberGroupId?: any): Observable<[]> {
    let params = memberGroupId ? '?member_group_id=' + memberGroupId : '';
    return this.http.get<ApiResponse>(`/vipsetting/getvipnamelocales${params}`).pipe(
      map(res => res.data.rows)
    )
  }

  private paginationInit(res: any) {
    if (res) {
      this.pagination = res.data.paginations;
    }
  }
}
